import React, { useEffect, useState } from 'react';
import styles from './Teachers.module.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { Helmet } from 'react-helmet-async';

const CATEGORY_ORDER = [
  { key: 'PRINCIPAL', label: 'Principal' },
  { key: 'VICE PRINCIPALS', label: 'Vice Principal' },
  { key: 'SUPERVISORS', label: 'Supervisors' },
  { key: 'HOD', label: 'HODs' },
  { key: 'TEACHERS', label: 'Teachers' },
  { key: 'OTHERS', label: 'Others' }
];

const Teachers = () => {
  const [teachersData, setTeachersData] = useState({});

  useEffect(() => {
    fetch('https://www.hillgreenhighschool.in/api/teachers.php')
      .then(res => res.json())
      .then(data => setTeachersData(data))
      .catch(err => console.error('API Error:', err));
  }, []);

  return (
    <>
      <Helmet>
        <title>Meet Our Teachers - Hillgreen High School</title>
        <meta
          name="description"
          content="Meet the dedicated educators of Hillgreen High School including Principal, Vice Principals, Supervisors, HODs and Teachers."
        />
        <link rel="canonical" href="https://www.hillgreenhighschool.in/teachers" />
      </Helmet>

      <div className={styles.teachers}>
        <div className={styles.teachers_head}>
          <div className={styles.overlay}></div>
          <div className={styles.teachers_head_text}>
            <ScrollAnimation animateIn="fadeIn">
              <h1>Teachers</h1>
            </ScrollAnimation>
          </div>
        </div>

        <main className={styles.teachers_main}>
          <ScrollAnimation animateIn="fadeInUp">
            <header className={styles.teacher_main_head}>
              <h2>Our Pillars</h2>
              <p>
                Our educators are experienced, dedicated and committed to
                nurturing excellence in academics and life.
              </p>
            </header>
          </ScrollAnimation>

          {/* ✅ Category-wise rendering */}
          {CATEGORY_ORDER.map(({ key, label }) =>
            teachersData[key]?.length > 0 ? (
              <section key={key} className={styles.teachersCategory}>
                

                <div className={styles.teachersList}>
                  {teachersData[key]
                    .filter(teacher => teacher.status === undefined || teacher.status === 1 || teacher.status === '1') // Filter Active
                    .sort((a, b) => {
                      // Sort by position (0 means no position, so push to end)
                      const posA = a.position ? parseInt(a.position, 10) : 0;
                      const posB = b.position ? parseInt(b.position, 10) : 0;
                      const valA = posA === 0 ? 999999 : posA;
                      const valB = posB === 0 ? 999999 : posB;
                      // Primary sort: position, Secondary sort: id DESC
                      return valA - valB || parseInt(b.id || 0) - parseInt(a.id || 0);
                    })
                    .map(teacher => (
                    <ScrollAnimation animateIn="fadeInUp" key={teacher.id}>
                      <article className={styles.teacherCard}>
                        <img
                          src={teacher.image_url}
                          alt={teacher.name}
                          className={styles.teacherImage}
                        />
                        <h3>{teacher.name}</h3>
                        <p>{teacher.designation}</p>
                        {teacher.description && <p>{teacher.description}</p>}
                      </article>
                    </ScrollAnimation>
                  ))}
                </div>
              </section>
            ) : null
          )}
        </main>
      </div>
    </>
  );
};

export default Teachers;
